import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import FancyToggle from '../elements/FancyToggle'
import FancySelectRow from '../elements/FancySelectRow'
import InputRowPaymentMethod from '../components/InputRowPaymentMethod'

const options = {
    postUrl: '/api/postPremiumSms',
    success: 'Success! Your premium SMS details have been updated.'
}

const state = {
    serviceId: '',
    mobile: '',
    active: '',
    spendLimit: ''
}

class PremiumSmsForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <FancyToggle
                    title='Premium SMS Active'
                    name='active'
                    value={this.props.values.active}
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                />
                {this.props.values.active
                    ? <div>
                        <InputRowReadOnly label='My mobile number' value={this.props.values.mobile} />
                        <InputRowPaymentMethod />

                        <FancySelectRow
                            label='Spend Limit'
                            name='spendLimit'
                            value={this.props.values.spendLimit}
                            errors={this.props.errors}
                            options={[
                                '$10',
                                '$20',
                                '$50',
                                '$100',
                                '$200'
                            ]}
                            handleChange={this.props.setDynamicValues}
                        />
                      </div>
                    : ''}

                {this.props.children}

                <div className='mt-4'>
                    <Button title='Submit Change' action={this.props.handleSubmit} />
                </div>
            </form>
        )
    }
}

export default FormHOC(PremiumSmsForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/PremiumSmsForm.js